import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import styled from "@mui/material/styles/styled";

import Stack from "@rui/Stack";

export const Container = styled(Stack)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 99, // must be lower than side nav
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
}));

export const Navigation = styled(BottomNavigation)(({ theme }) => ({
  borderTop: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  height: "64px",
  alignItems: "center",
}));

export const NavigationButton = styled(BottomNavigationAction)(({ theme }) => ({
  flexDirection: "row",
  color: theme.palette.shades.neutral[500],
  borderRadius: "8px",
  height: "40px",
  padding: "0px 6px",
  minWidth: 0,
  width: "fit-content",
  "&.Mui-selected": {
    color: theme.palette.shades.primary[500],
    backgroundColor: theme.palette.shades.ghost[500],
  },
  "& .MuiBottomNavigationAction-label": {
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  "& .MuiSvgIcon-root": {
    fontSize: "16px",
    marginRight: theme.spacing(1),
  },
}));
